import React, { useLayoutEffect } from "react"
import Media from 'react-media';
import { Link } from "gatsby-plugin-intl"
import { injectIntl } from "gatsby-plugin-intl"

import logo from "../images/logo-orange.svg"
import logo_mobile from "../images/logo_mobile.svg"
import menu_icon from "../images/icon-menu.svg"
import "./header.scss"

let _ticking = false
    //_lastTop = 0

const _onScroll = ( e ) => {
  if( !_ticking ) {
    window.requestAnimationFrame(() => {
      let header = document.getElementById( 'header' ),
          top = window.pageYOffset || document.documentElement.scrollTop,
          classes = [ 'header' ]

      if( top < window.innerHeight ) {
        classes.push( 'overHeader' )
      }

      //if( top > _lastTop ) {
      //  classes.push( 'hidden' )
      //} else {
      //  classes.push( top ? 'show' : null )
      //}

      header.className = classes.join( ' ' )
      //_lastTop = top
      _ticking = false
    });

    _ticking = true
  }
}

const _preventScroll = ( e ) => e.preventDefault()
const _addScrollListener = ( menuOpened ) => {
  if( typeof window !== 'undefined' ) {
      let header = document.getElementById( 'header' )

      window.addEventListener( 'scroll', _onScroll )

      if( menuOpened ) {
        header.addEventListener( 'touchmove', _preventScroll, false )
      } else {
        header.removeEventListener( 'touchmove', _preventScroll )
      }

      return () => {
        window.removeEventListener( 'scroll', _onScroll )
      }
  }

}

const Header = ( { pathname, menuOpened, toggleMenu, intl } ) => {
  let [ lang, page, case_name ] = pathname.substr( 1 ).split( '/' )
  let classNames = [ "header", "overHeader" ]

  if (case_name) {
   page = page+'/'+case_name
  }

  if( lang === '.alpha' ) {
    lang = page
  }

  useLayoutEffect( _addScrollListener.bind( this, menuOpened ) )

  const hirelink = lang === 'pt'
        ? <a href="/vagas" target="_blank" rel="noopener noreferrer"> { intl.formatMessage( { id: "nav-link.hiring" } ) } </a>
        : <a href="/research" target="_blank" rel="noopener noreferrer"> Need a research project? { intl.formatMessage( { id: "nav-link.hiring" } ) } </a>

const headerLogo =  <Media queries={{ small: { maxWidth: 575 } }}>
          {matches =>
            matches.small ? (
              <embed src={ logo_mobile } />
            ) : (
             <embed src={ logo} />
            )
          }
        </Media>;

  return (
    <header id="header" className={ classNames.join( ' ' ) }>
      <Link className="logo" to="/" >{headerLogo}</Link>
      <button className="menu-toggle" onClick={ e => toggleMenu( !menuOpened ) } >Menu <img src={ menu_icon } alt=""/></button>
      <div className="break" ></div>
      <ul className="menu main-menu" >
        <li><Link to="/about" >{ intl.formatMessage( { id: "nav-link.about" } ) }</Link></li>
        <li><Link to="/#cases" >{ intl.formatMessage( { id: "nav-link.cases" } ) }</Link></li>
        <li><Link to="/contact" >{ intl.formatMessage( { id: "nav-link.contact" } ) }</Link></li>
      </ul>
      <ul className="menu secondary-menu">
        <li > { hirelink } </li>
        <li><Link language="pt" to={ `/${ page }` }>PT</Link></li>
        <li><Link language="en" to={ `/${ page }` }>EN</Link></li>
      </ul>
    </header>
  )
}

//Header.propTypes = {
//  siteTitle: PropTypes.string,
//}
//
//Header.defaultProps = {
//  siteTitle: `Try consultoria`,
//}

export default injectIntl( Header )
